<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">

    <app-transferperiod-stepper [activeAction]="activeAction"></app-transferperiod-stepper>

    
    <!-- start header --> 
    @if(!processing() && poolUser && assembleFormation){
      <div class="d-flex justify-content-between mt-3 mb-1">
        <!-- left -->      
        @if(hasPlayersWithoutCurrentTeam(poolUser.getPool(), assembleFormation)){
          <button class="btn btn-outline-primary btn-sm"
            (click)="linkToReplacements(poolUser, assembleFormation, contentRemove)">
            <fa-icon [icon]=faChevronLeft></fa-icon>
            <fa-icon [icon]=faChevronLeft></fa-icon>
          </button>
        }
          
        
        <!-- center/right -->
        <div class="d-flex">    
          @let transfers = poolUser.getTransferPeriodActionList().transfers;
          @if(transferEditMode === SingleEditMode && transfers.length < transferPeriod.getMaxNrOfTransfers()){
            <button class="btn btn-outline-primary ms-1" (click)="toggleTransferEditMode(contentInfo)">
              <fa-icon [icon]=faUsers></fa-icon>
            </button>
          }
          @if(transferEditMode === DoubleEditMode && (transfers.length + 1) < transferPeriod.getMaxNrOfTransfers()){
            <button class="btn btn-secondary ms-1"(click)="toggleTransferEditMode(contentInfo)">
              <fa-icon [icon]=faUserCircle></fa-icon>
            </button>
          }
          @if(transfers.length){ 
            <button type="button" class="btn btn-primary ms-1" 
            (click)="remove(poolUser.getPool(),assembleFormation, transfers, false)">
            <fa-icon [icon]=faTrashAlt></fa-icon>
          </button>
          }
          @if(pool && calcFormation){            
            <button class="btn btn-secondary mx-2" disabled>
              {{calcFormation.getName()}}
            </button>
          }
        </div>

        <!-- right -->    
        <button class="btn btn-outline-primary mx-1" (click)="linkToSubstitutions(poolUser.getPool())">
          naar wisselen <fa-icon [icon]=faChevronRight></fa-icon>
          <fa-icon [icon]=faChevronRight></fa-icon>
        </button>
        
      </div> <!-- end header --> 
    }
    
    @if(alert){
    <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
    }

    @if(!processing() && pool && poolUser && assembleFormation && calcFormation){
    <div>
      @if(!selectedPlace){      
        @for(line of calcFormation.getLines();track line.getNumber()) {
          <app-pool-formationline-transfers [line]="line"
            [transfers]="poolUser.getTransferPeriodActionList().transfers" [maxNrOfTransfers]="transferPeriod.getMaxNrOfTransfers()"
            [canRemoveTransfer]="canRemoveTransfer(calcFormation,line)"
            (transfer)="linkToTransfer(pool,$event)" (linkToPlayer)="linkToPlayer(pool,$event)"
            (remove)="remove(pool, assembleFormation, $event, false)">
          </app-pool-formationline-transfers>
        }
      }
    </div>
    }
  </div>
</div>

@if(!processing() && pool){
<app-pool-navbar [pool]="pool" [poolUser]="poolUser"></app-pool-navbar>
}

<ng-template #contentRemove let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <span>transfers verwijderen</span>
    </h4>
    <button type="button" class="btn-close" aria-label="sluiten" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Je transfers worden ongedaan gemaakt wanneer je naar "gestopte spelers vervangen" gaat</p>
  </div>
  <div class="modal-footer d-flex justify-content-reverse border-top-0">
    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modal.close(poolUser)">
      ga naar "gestopte spelers vervangen"</button>
  </div>
</ng-template>


<ng-template #contentInfo let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <span>dubbele transfer</span>
    </h4>
    <button type="button" class="btn-close" aria-label="sluiten" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Wil je een dubbele transfer <span class="fw-bold">met keeper</span> doen?</p>
    <p>
      <a href="mailto:info@superelf-eredivisie.nl" rel="noopener">
        <fa-icon [icon]=faEnvelope></fa-icon> info&#64;superelf-eredivisie.nl
      </a>
    </p>
    <p>
      bijvoorbeeld : <br/>
      eruit : Bijlow  (FEY - K) en Xavi Simons (PSV - M)<br/>
      erin  : Benitez (PSV - K) en Kokcu (FEY - M)
    </p>
  </div>
</ng-template>

